import { IClassname } from '@/lib/shared/model/classname';

export const Gardening = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14444_540)">
        <path
          d="M16.639 10.8887L13.342 18.0322C13.2611 18.1539 13.2173 18.2964 13.2159 18.4424C13.2144 18.5885 13.2555 18.7318 13.334 18.855C13.4125 18.9781 13.5251 19.0759 13.6581 19.1363C13.7911 19.1966 13.9388 19.2171 14.0832 19.1951H17.278C17.4203 19.168 17.5675 19.1847 17.7002 19.243C17.8329 19.3013 17.9447 19.3986 18.0209 19.5219C18.0971 19.6452 18.134 19.7887 18.1269 19.9334C18.1197 20.0781 18.0688 20.2173 17.9808 20.3325L14.7221 26.8626"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.4441 24.3066L14.722 26.8625L17.9168 25.5846"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.58198 30.6964H29.4182C29.6441 30.6996 29.8667 30.6428 30.0635 30.532C30.2602 30.4211 30.4241 30.2601 30.5384 30.0653C30.6527 29.8705 30.7133 29.6488 30.7141 29.423C30.7148 29.1971 30.6557 28.9751 30.5428 28.7795L17.1375 1.94328C17.0302 1.73396 16.8673 1.55829 16.6666 1.43562C16.4659 1.31295 16.2353 1.24805 16.0001 1.24805C15.7649 1.24805 15.5343 1.31295 15.3336 1.43562C15.1329 1.55829 14.97 1.73396 14.8628 1.94328L1.45741 28.7795C1.34446 28.9751 1.28537 29.1971 1.28614 29.423C1.28691 29.6488 1.34753 29.8705 1.46181 30.0653C1.5761 30.2601 1.73997 30.4211 1.93674 30.532C2.13351 30.6428 2.35615 30.6996 2.58198 30.6964Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14444_540">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
